import React from "react";
import { Grid, CircularProgress, Typography } from "@mui/material";
export const LoadingProgress = ({ text = "Loading..." }) => (
  <Grid container justifyContent="center" alignItems="center" spacing={1}>
    <Grid item>
      <CircularProgress size={25} thickness={4} />
    </Grid>
    <Grid item>
      <Typography>{text}</Typography>
    </Grid>
  </Grid>
);
